<template lang="pug">
.menu-items-wrapper
    slot
</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";

export default {
    components: {
        MenuItem
    }
}
</script>

<style lang="scss" scoped>
.menu-items-wrapper {
  margin: $md-space 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-gap: $sm-space $md-space;
}
</style>